import React, { useState, useEffect, useRef } from "react";
import {
  addDoc,
  serverTimestamp,
  collection,
  doc,
  deleteDoc,
  updateDoc,
  getDoc,
} from "firebase/firestore";
import { db, storage } from "../authentication/firebase/firebase";
import { onSnapshot, query, where, orderBy } from "firebase/firestore";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import "./chat-room.scss";
const ChatRoom = ({
  forumAddress,
  username,
  chatroomId,
  setDisplayChatroom,
  setShowMenu,
  chatroomTitle,
  selectedPost,
  setSelectedPost,
  displayForumNone,
}) => {
  const [newMessage, setNewMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedImagePreview, setSelectedImagePreview] = useState(null);
  const messagesContainerRef = useRef(null);
  const [hoveredMessageId, setHoveredMessageId] = useState(null);
  const [deletePostModal, setDeletePostModal] = useState(false);
  const [replyMessageUsername, setReplyMessageUsername] = useState("");
  const [replyMessageText, setReplyMessageText] = useState("");
  // const [replyMessageImage, setReplyMessageImage] = useState("");
  const [replying, setReplying] = useState(false);
  const [messageIsReply, setMessageIsReply] = useState(false);
  const [editMessageText, setEditMessageText] = useState("");
  const [editingMessageId, setEditingMessageId] = useState("");
  const [editingPostTitleId, setEditingPostTitleId] = useState(null);
  const [editPostTitle, setEditPostTitle] = useState("");
  const [editingPostTextId, setEditingPostTextId] = useState(null);
  const [editPostText, setEditPostText] = useState("");
  const [isHovering, setIsHovering] = useState(false);
  const [makeImageBigger, setMakeImageBigger] = useState(false);
  const [makeImageBiggerUrl, setMakeImageBiggerUrl] = useState("");

  const messageCollectionRef = collection(db, "messages");

  const handleSubmit = async (e) => {
    e.preventDefault();
    sendMessage();
  };

  const handleFileSelect = (e) => {
    setSelectedFile(e.target.files[0]);

    if (e.target.files[0]) {
      const imageURL = URL.createObjectURL(e.target.files[0]);
      setSelectedImagePreview(imageURL);
    }
  };

  const handleDeselectImage = () => {
    setSelectedFile(null);
    setSelectedImagePreview(null);
  };

  const sendMessage = async () => {
    setReplying(false);

    let imageURL = null;

    if (selectedFile) {
      const storageRef = ref(storage, `images/${selectedFile.name}`);
      const uploadTask = uploadBytesResumable(storageRef, selectedFile);

      await uploadTask.then(async (snapshot) => {
        const downloadURL = await getDownloadURL(snapshot.ref);
        imageURL = downloadURL;
      });
    }
    if (!newMessage.trim() && !imageURL) {
      alert("Please enter a valid response");
      return;
    }

    if (newMessage || imageURL) {
      await addDoc(messageCollectionRef, {
        text: newMessage,
        image: imageURL,
        createdAt: serverTimestamp(),
        username: username,
        chatroomId,
        forumAddress,
        reply: messageIsReply,
        replyMessageUsername: replyMessageUsername,
        replyMessageText: replyMessageText,
      });

      setNewMessage("");
      setSelectedFile(null);
      setSelectedImagePreview(null);
      handleCancelReply(true);
    }
  };

  useEffect(() => {
    const queryMessages = query(
      messageCollectionRef,
      where("chatroomId", "==", chatroomId),
      orderBy("createdAt")
    );

    const unsubscribe = onSnapshot(queryMessages, (snapshot) => {
      let messagesData = [];
      snapshot.forEach((doc) => {
        messagesData.push({ ...doc.data(), id: doc.id });
      });
      setMessages(messagesData);

      setTimeout(() => {
        if (messagesContainerRef.current) {
          messagesContainerRef.current.scrollTop =
            messagesContainerRef.current.scrollHeight;
        }
      }, 100);
    });

    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatroomId]);

  const handleImageLoad = () => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }
  };

  const handleFormatChange = () => {
    // setShowMenu(true);
    setDisplayChatroom(false);
  };

  const handleDeleteMessage = async (id, imageUrl) => {
    const messageRef = doc(db, "messages", id);
    await deleteDoc(messageRef);

    if (imageUrl) {
      try {
        const imageRef = ref(storage, imageUrl);
        await deleteObject(imageRef);
      } catch (err) {
        alert("There was an error.");
      }
    }
  };

  const handleEditMessage = async (id) => {
    if (editMessageText.trim() === "") {
      alert("Please enter a valid message");
      return;
    }
    try {
      const messageRef = doc(db, "messages", id);
      await updateDoc(messageRef, { text: editMessageText });
    } catch (error) {
      console.error(error);
    }

    setEditingMessageId("");
  };
  const handleEditPostTitle = async (postId) => {
    if (editPostTitle.trim() === "") {
      alert("Please enter a valid title");
      return;
    }
    try {
      const postRef = doc(db, "posts", postId);
      await updateDoc(postRef, { title: editPostTitle });

      // Fetch the updated post from the database
      const updatedPostSnapshot = await getDoc(postRef);
      const updatedPostData = updatedPostSnapshot.data();

      // Update the selectedPost title with the newest value
      setSelectedPost({ ...selectedPost, title: updatedPostData.title });
    } catch (error) {
      console.error("Error updating post title: ", error);
    }

    setEditingPostTitleId(null);
    setEditPostTitle("");
  };

  // Function to initiate editing of the post title
  const startEditingPostTitle = () => {
    setEditingPostTitleId(selectedPost.id);
    setEditPostTitle("");
  };

  const handleEditPostText = async (postId) => {
    if (editPostText.trim() === "") {
      alert("Please enter a valid text");
      return;
    }
    try {
      const postRef = doc(db, "posts", postId);
      await updateDoc(postRef, { text: editPostText });

      // Fetch the updated post from the database
      const updatedPostSnapshot = await getDoc(postRef);
      const updatedPostData = updatedPostSnapshot.data();

      // Update the selectedPost title with the newest value
      setSelectedPost({ ...selectedPost, text: updatedPostData.text });
    } catch (error) {
      console.error("Error updating post text: ", error);
    }

    setEditingPostTextId(null);
    setEditPostText("");
  };

  // Function to initiate editing of the post title
  const startEditingPostText = () => {
    setEditingPostTextId(selectedPost.id);
    setEditPostText("");
  };

  const handleDeletePost = async (postId) => {
    try {
      await deleteDoc(doc(db, "posts", postId));
      setDeletePostModal(false);
      setDisplayChatroom(false);
    } catch (error) {
      console.error("Error deleting post: ", error);
    }
  };

  function formatTimestamp(timestamp) {
    const date = timestamp.toDate();

    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    return date.toLocaleString("en-US", options);
  }

  const handleReply = (messageInfo) => {
    setReplying(true);
    setReplyMessageUsername(messageInfo.username);
    setReplyMessageText(messageInfo.text);
    // setReplyMessageImage(messageInfo.image);
    setMessageIsReply(true);
  };

  const handleCancelReply = () => {
    setReplying(false);
    setReplyMessageUsername("");
    setReplyMessageText("");
    // setReplyMessageImage("");
    setMessageIsReply(false);
  };

  // const handleMouseEnter = () => {
  //   setIsHovering(true);
  // };

  // const handleMouseLeave = () => {
  //   setIsHovering(false);
  // };

  const handleMakeImageBigger = (imageUrl) => {
    setMakeImageBiggerUrl(imageUrl);
    setMakeImageBigger(true);
  };

  const handleMakeImageSmaller = () => {
    setMakeImageBiggerUrl("");
    setMakeImageBigger(false);
  };

  return (
    <div
      className="chatroom-container"
      style={{ width: displayForumNone ? "100%" : "" }}
    >
      <div className="top-buttons-container">
        <button
          onClick={handleFormatChange}
          type="button"
          className="close-message-room"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        {selectedPost.username === username && (
          <button
            className="delete-post-button"
            onClick={() => setDeletePostModal(true)}
          >
            Delete Post
          </button>
        )}
      </div>
      <div
        className="display-messages"
        ref={messagesContainerRef}
        style={{ width: displayForumNone ? "100%" : "35vw" }}
      >
        <div className="message-title-container">
          <div className="post-message-title">
            <header
              onMouseEnter={() => setIsHovering(true)}
              onMouseLeave={() => setIsHovering(false)}
            >
              <h1>💬 {selectedPost.title}</h1>
              {selectedPost.username === username && (
                <button
                  onClick={startEditingPostTitle}
                  style={{ display: isHovering ? "block" : "none" }}
                >
                  ✏️
                </button>
              )}
            </header>
            {editingPostTitleId === selectedPost.id && (
              <form
                onSubmit={(e) => e.preventDefault()}
                className="edit-title-container"
              >
                <button onClick={() => setEditingPostTitleId("")}>
                  <i className="fa-solid fa-xmark"></i>
                </button>
                <input
                  placeholder="New Title..."
                  maxLength={100}
                  value={editPostTitle}
                  onChange={(e) => setEditPostTitle(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleEditPostTitle(selectedPost.id);
                    }
                  }}
                />
                <button
                  onClick={() => handleEditPostTitle(selectedPost.id)}
                  type="submit"
                >
                  Update
                </button>
              </form>
            )}
            <h2>Asked by: {selectedPost.username}</h2>
          </div>
          {selectedPost.text !== "" || selectedPost.image ? (
            <div
              className="post-message-container"
              onMouseEnter={() => setHoveredMessageId(selectedPost.id)}
              onMouseLeave={() => setHoveredMessageId(null)}
            >
              <header>
                <h3>{selectedPost.username}</h3>
                <div className="post-message-left-header-container">
                  {hoveredMessageId === selectedPost.id && (
                    <div className="hover-post-message-buttons">
                      {selectedPost.username === username && (
                        <button
                          onClick={startEditingPostText}
                          className="edit-text-button"
                        >
                          ✏️
                        </button>
                      )}

                      <button
                        onClick={() => handleReply(selectedPost)}
                        className="reply-text-button"
                      >
                        ➦
                      </button>
                    </div>
                  )}

                  <h4>
                    {selectedPost.createdAt &&
                      formatTimestamp(selectedPost.createdAt)}
                  </h4>
                </div>
              </header>
              <div className="selected-post-message-content">
                <p>{selectedPost.text}</p>

                {editingPostTextId === selectedPost.id && (
                  <form
                    onSubmit={(e) => e.preventDefault()}
                    className="post-edit-text"
                  >
                    <button onClick={() => setEditingPostTextId("")}>
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                    <input
                      placeholder="New Text..."
                      maxLength={200}
                      value={editPostText}
                      onChange={(e) => setEditPostText(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleEditPostText(selectedPost.id);
                        }
                      }}
                    />
                    <button onClick={() => handleEditPostText(selectedPost.id)}>
                      Update
                    </button>
                  </form>
                )}

                {selectedPost.image && (
                  <img
                    src={selectedPost.image}
                    alt="User Uploaded"
                    className="user-image"
                    onLoad={handleImageLoad}
                    onClick={() => handleMakeImageBigger(selectedPost.image)}
                  />
                )}
              </div>
            </div>
          ) : null}
        </div>
        {messages.map((message) => (
          <div
            className="message-edit-container"
            key={message.id}
            onMouseEnter={() => setHoveredMessageId(message.id)}
            onMouseLeave={() => setHoveredMessageId(null)}
          >
            <header>
              <h3>{message.username}</h3>
              <div className="message-left-header-container">
                <div className="hover-message-items-container">
                  {hoveredMessageId === message.id && (
                    <div className="hover-message-buttons">
                      {message.username === username && (
                        <button
                          onClick={() => setEditingMessageId(message.id)}
                          className="hover-message-edit-button"
                        >
                          ✏️
                        </button>
                      )}
                      <button
                        onClick={() => handleReply(message)}
                        className="hover-message-reply-button"
                      >
                        ➦
                      </button>
                      {message.username === username && (
                        <button onClick={() => handleDeleteMessage(message.id)}>
                          🗑️
                        </button>
                      )}
                    </div>
                  )}
                </div>
                <h4>
                  {message.createdAt && formatTimestamp(message.createdAt)}
                </h4>
              </div>
            </header>
            <div className="message-content">
              {message.reply === true && (
                <div className="reply-message-content">
                  <p style={{ fontWeight: "500" }}>
                    <span style={{ color: "#ff5823" }}>Replying to: </span>
                    <span>
                      {message.replyMessageUsername}:{" "}
                      {message.replyMessageText &&
                        message.replyMessageText.substring(0, 20)}
                      ...
                    </span>
                  </p>
                </div>
              )}
              <p>{message.text}</p>

              {message.id === editingMessageId && (
                <div className="edit-message-container">
                  <form onSubmit={(e) => e.preventDefault()}>
                    <button onClick={() => setEditingMessageId("")}>
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                    <input
                      placeholder="New Message..."
                      maxLength={2000}
                      onChange={(e) => setEditMessageText(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleEditMessage(message.id);
                        }
                      }}
                    />
                    <button onClick={() => handleEditMessage(message.id)}>
                      Update
                    </button>
                  </form>
                </div>
              )}

              {message.image && (
                <img
                  src={message.image}
                  alt="User Uploaded"
                  className="user-image"
                  onLoad={handleImageLoad}
                  onClick={() => handleMakeImageBigger(message.image)}
                />
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="chatroom-bottom-container">
        {replying && (
          <div className="reply-message-container">
            <button onClick={handleCancelReply}>
              <i class="fa-solid fa-xmark"></i>
            </button>
            <p>
              Replying to:{" "}
              <span style={{ color: "#ff5823" }}>{replyMessageUsername}</span>{" "}
              <span className="reply-message-text">
                {" "}
                ({replyMessageText && replyMessageText.substring(0, 5)}...)
              </span>
            </p>
          </div>
        )}

        <form
          className="create-message"
          onSubmit={handleSubmit}
          style={{ marginTop: replying ? "-3.297rem" : "" }}
        >
          <div className="share-prev-image-container">
            <label className="upload-image">
              📤
              <input
                type="file"
                accept="image/*"
                onChange={handleFileSelect}
                style={{ display: "none" }}
                className="choose-img-btn"
              />
            </label>
            {selectedImagePreview && (
              <div className="selected-image-container">
                <img
                  className="selected-image-preview"
                  src={selectedImagePreview}
                  alt="Selected Preview"
                />
                <button
                  className="deselect-image-button"
                  onClick={handleDeselectImage}
                >
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </div>
            )}
          </div>
          <input
            className="input"
            placeholder="Type your message here..."
            onChange={(e) => setNewMessage(e.target.value)}
            value={newMessage}
            maxLength={2000}
            style={{ width: selectedImagePreview ? "45%" : "60%" }}
          />

          <button type="submit" className="send-button" onClick={handleSubmit}>
            Send
          </button>
        </form>
      </div>
      {deletePostModal && (
        <div className="delete-post-message-modal">
          <div className="delete-post-message-container">
            <h3>Are you sure you want to delete this post?</h3>
            <div className="delete-post-message-buttons">
              <button onClick={() => handleDeletePost(selectedPost.id)}>
                YES
              </button>
              <button onClick={() => setDeletePostModal(false)}>NO</button>
            </div>
          </div>
        </div>
      )}
      {makeImageBigger && (
        <div className="bigger-image-modal">
          <img
            src={makeImageBiggerUrl}
            alt="bigger"
            onClick={handleMakeImageSmaller}
          />
        </div>
      )}
    </div>
  );
};

export default ChatRoom;
